<!-- Hidden label template rendered for PDF capture — MUST be outside nz-skeleton -->
<div style="position:fixed;left:-9999px;top:0;width:fit-content;">
  <app-label-template
    #labelTemplate
    [uploadedImage]="uploadedImage()"
    [base64DefaultLogo]="base64DefaultLogo()"
    [base64SapLogo]="base64SapLogo()"
    [base64Barcode]="base64Barcode()"
    [base64Watermark]="base64Watermark()"
    [contentItems]="contentItems()"
    [isWatermarkShow]="isWatermarkShow()"
    [isPhoneSenderShow]="isPhoneSenderShow()"
    [isAddressSenderShow]="isAddressSenderShow()"
    [isPhoneReceiverShow]="isPhoneReceiverShow()"
    [isNameReceiverShow]="isNameReceiverShow()"
    [isQuantityShow]="isQuantityShow()"
    [isPackageShow]="isPackageShow()"
    [isInsuranceShow]="isInsuranceShow()"
    [selectedLabel]="selectedLabel() || 'a4'"
  ></app-label-template>
</div>

<div class="card p-4 flex flex-col mt-2">
  <nz-skeleton
    [ngClass]="skeleton() ? 'p-3' : 'p-0'"
    [nzLoading]="skeleton()"
    [nzActive]="true"
    [nzParagraph]="false"
  >
    <div class="py-1 title">Customize Label Receipt</div>
    <span
      >Changes made here will be applied to the shipping label generated via
      API</span
    >
    <hr />
    <div class="flex flex-col md:flex-row gap-4 w-full mt-4">
      <div class="flex flex-col gap-2 w-full md:w-2/5">
        <div class="flex justify-between items-center gap-2">
          <span class="text-bold text-[16px]">Contents</span>
          <button class="btn w-fit" [ngClass]="isEditMode() ? 'btn-outline-secondary' : 'btn-outline-primary'" [disabled]="isEditMode()" (click)="toggleEditMode()">
            <div class="flex items-center justify-center gap-2">
              <span>Edit</span>
              <img
                [src]="isEditMode() ? 'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/edit.svg' : 'https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/edit.svg'"
                alt="edit"
                width="16"
                height="16"
              />
            </div>
          </button>
        </div>
        <div class="flex flex-col gap-2 mt-3">
          <div
            *ngFor="let item of contentItems()"
            class="flex items-center gap-3"
          >
            <input
              class="form-check-input !w-[16px] !h-[16px] custom-disabled-checkbox"
              type="checkbox"
              [value]="item.value"
              [id]="item.value"
              [(ngModel)]="item.checked"
              (ngModelChange)="onCheckboxChange()"
              [disabled]="!isEditMode()"
            />
            <label class="form-check-label" [for]="item.value">
              {{ item.label }}
            </label>
          </div>
        </div>
        <div class="mt-4">
          <span class="text-bold">Replace Logo</span>
          <div *ngIf="uploadedImage()" class="flex mt-2" style="height: 60px">
            <img
              [src]="uploadedImage()"
              alt="profile"
              class="rounded"
              crossOrigin="anonymous"
              referrerpolicy="no-referrer"
              style="max-width: 140px; max-height: 40px; object-fit: cover"
            />
          </div>
          <div class="flex flex-col gap-1 mb-2 mt-3 w-full">
            <div *ngIf="!uploadedImage()" class="flex flex-col gap-2">
              <button
                class="btn btn-outline-primary w-1/2"
                (click)="triggerFileInput()"
                [disabled]="!isEditMode()"
              >
                Upload
              </button>
              <span class="text-secondary">*PNG, Max 1MB, 140 × 40 px</span>
            </div>
            <span *ngIf="uploadError()" class="text-danger small">{{
              uploadError()
            }}</span>
            <div *ngIf="uploadedImage()" class="flex gap-2 items-center">
              <img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/paperclip-2.svg"
                alt="file"
                style="width: 16px; height: 16px"
              />
              <span class="text-wrap">{{ photoName() }}</span>
              <button
                *ngIf="isEditMode()"
                class="btn p-0"
                (click)="deleteImage()"
              >
                <img
                  src="https://storage.googleapis.com/komerce/assets/icons/close-circle-red.svg"
                  alt="delete"
                  style="width: 16px; height: 16px"
                />
              </button>
            </div>
          </div>
          <input
            type="file"
            name="file"
            class="form-control d-none"
            id="attachment"
            (change)="handleFileUpload($event)"
            #fileupload
          />
        </div>
        <button
          [disabled]="!isEditMode() || isSaving() || !hasChanges()"
          class="btn w-full mt-4"
          [ngClass]="!isEditMode() || isSaving() || !hasChanges() ? 'btn-secondary' : 'btn-primary'"
          (click)="saveCustomLabelConfig()"
        >
          <span *ngIf="isSaving()" class="spinner-border spinner-border-sm me-1" role="status"></span>
          Save
        </button>
      </div>
      <div class="flex flex-col gap-2 w-full">
        <div class="flex flex-col md:flex-row gap-2 justify-between items-center">
          <span class="text-bold text-[16px]">PDF Preview</span>
          <div class="flex gap-2">
            <div class="flex flex-col gap-2">
              <nz-select
                [ngModel]="selectedLabel()"
                (ngModelChange)="onLabelChange($event)"
                nzPlaceHolder="Select Size"
                class="w-[200px] rounded-lg"
                [nzSize]="'large'"
              >
                <nz-option *ngFor="let item of labelList()" [nzValue]="item.value" [nzLabel]="item.label"></nz-option>
              </nz-select>
            </div>
            <button class="btn btn-primary w-fit" (click)="downloadPdf()" [disabled]="!lastPdfBlob() || isGenerating()">
              <span *ngIf="isGenerating()" class="spinner-border spinner-border-sm me-1" role="status"></span>
              Download Label
            </button>
          </div>
        </div>

        <!-- PDF Viewer -->
        <div class="w-full h-[500px] border border-dashed rounded-lg mt-2 overflow-hidden relative bg-gray-50 flex items-center justify-center">
          <div *ngIf="isGenerating()" class="flex flex-col items-center gap-2 text-secondary">
            <span class="spinner-border" role="status"></span>
            <small>Generating Label Receipt...</small>
          </div>
          <iframe
            *ngIf="!isGenerating() && pdfDataUrl()"
            #pdfViewer
            [src]="pdfDataUrl()"
            class="w-full h-full border-0"
            title="PDF Preview"
          ></iframe>
        </div>
      </div>
    </div>
  </nz-skeleton>
</div>
